var _path, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersons({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 101,
    viewBox: "0 0 87 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3915 35.0339C21.3915 43.0976 27.8236 49.5596 35.8499 49.5596C43.8733 49.5596 50.3083 43.0976 50.3083 35.0339C50.3083 26.9702 43.8733 20.5082 35.8499 20.5082C27.8236 20.5082 21.3915 26.9702 21.3915 35.0339ZM57.701 66.0063C57.701 58.5417 47.6354 56.6741 35.8505 56.6741C24.0016 56.6741 14 58.606 14 66.0764C14 73.5409 24.0656 75.4085 35.8505 75.4085C47.6994 75.4085 57.701 73.4766 57.701 66.0063Z",
    fill: "url(#paint0_linear_9902_29174)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9902_29174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.596 61.4616C47.7914 61.4616 53.937 62.702 53.937 67.6594C53.937 72.6207 47.8305 73.9037 40.596 73.9037C33.4007 73.9037 27.2551 72.6634 27.2551 67.706C27.2551 62.7447 33.3616 61.4616 40.596 61.4616Z",
    fill: "#8237FF",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_9902_29174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3832 42.3839C35.3436 42.3839 32.1063 39.0628 32.1063 34.9186C32.1063 30.7744 35.3436 27.4534 39.3832 27.4534C43.4214 27.4534 46.6601 30.7744 46.6601 34.9186C46.6601 39.0628 43.4214 42.3839 39.3832 42.3839Z",
    fill: "#8237FF",
    fillOpacity: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_9902_29174)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_9902_29174",
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 14,
    width: 60,
    height: 74,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 27,
    y: 14,
    width: 60,
    height: 74
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3833 34.0496C38.3833 44.6247 46.8186 53.0993 57.3446 53.0993C67.8668 53.0993 76.306 44.6247 76.306 34.0496C76.306 23.4746 67.8668 15 57.3446 15C46.8186 15 38.3833 23.4746 38.3833 34.0496ZM86 74.6695C86 64.8802 72.7995 62.431 57.3443 62.431C41.8052 62.431 28.6887 64.9645 28.6887 74.7615C28.6887 84.5508 41.8891 87 57.3443 87C72.8835 87 86 84.4664 86 74.6695Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3833 34.0496C38.3833 44.6247 46.8186 53.0993 57.3446 53.0993C67.8668 53.0993 76.306 44.6247 76.306 34.0496C76.306 23.4746 67.8668 15 57.3446 15C46.8186 15 38.3833 23.4746 38.3833 34.0496ZM86 74.6695C86 64.8802 72.7995 62.431 57.3443 62.431C41.8052 62.431 28.6887 64.9645 28.6887 74.7615C28.6887 84.5508 41.8891 87 57.3443 87C72.8835 87 86 84.4664 86 74.6695Z",
    fill: "#BA90FF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3446 54.0993C46.2619 54.0993 37.3833 45.1726 37.3833 34.0496H39.3833C39.3833 44.0768 47.3752 52.0993 57.3446 52.0993V54.0993ZM77.306 34.0496C77.306 45.1727 68.4233 54.0993 57.3446 54.0993V52.0993C67.3103 52.0993 75.306 44.0766 75.306 34.0496H77.306ZM57.3446 14C68.4233 14 77.306 22.9266 77.306 34.0496H75.306C75.306 24.0226 67.3103 16 57.3446 16V14ZM37.3833 34.0496C37.3833 22.9267 46.2619 14 57.3446 14V16C47.3752 16 39.3833 24.0225 39.3833 34.0496H37.3833ZM57.3443 61.431C65.0947 61.431 72.4 62.0411 77.799 63.9356C80.5052 64.8853 82.803 66.1814 84.4316 67.95C86.0811 69.7414 87 71.972 87 74.6695H85C85 72.4723 84.2688 70.7258 82.9603 69.3047C81.6308 67.8609 79.6626 66.7092 77.1368 65.8228C72.0717 64.0454 65.0492 63.431 57.3443 63.431V61.431ZM27.6887 74.7615C27.6887 72.0643 28.6006 69.8284 30.2419 68.028C31.8628 66.25 34.1523 64.9416 36.8541 63.9802C42.2439 62.0623 49.5504 61.431 57.3443 61.431V63.431C49.5991 63.431 42.5778 64.0664 37.5246 65.8645C35.0048 66.7611 33.0439 67.9231 31.7199 69.3754C30.4162 70.8055 29.6887 72.5602 29.6887 74.7615H27.6887ZM57.3443 88C49.594 88 42.2887 87.3899 36.8897 85.4953C34.1835 84.5457 31.8856 83.2496 30.2571 81.481C28.6075 79.6895 27.6887 77.459 27.6887 74.7615H29.6887C29.6887 76.9586 30.4199 78.7052 31.7284 80.1262C33.0579 81.5701 35.0261 82.7218 37.5519 83.6081C42.6169 85.3855 49.6395 86 57.3443 86V88ZM87 74.6695C87 77.3667 86.088 79.6025 84.4468 81.4029C82.8258 83.181 80.5364 84.4893 77.8346 85.4507C72.4448 87.3686 65.1382 88 57.3443 88V86C65.0896 86 72.1109 85.3646 77.1641 83.5665C79.6838 82.6699 81.6447 81.5079 82.9687 80.0555C84.2724 78.6255 85 76.8708 85 74.6695H87Z",
    fill: "url(#paint1_linear_9902_29174)",
    mask: "url(#path-4-outside-1_9902_29174)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9902_29174",
    x: 0.255066,
    y: 34.4616,
    width: 80.6819,
    height: 66.442,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5,
    result: "effect1_foregroundBlur_9902_29174"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_9902_29174",
    x: 5.10632,
    y: 0.4534,
    width: 68.5538,
    height: 68.9305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5,
    result: "effect1_foregroundBlur_9902_29174"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_9902_29174",
    x: 3.68866,
    y: -10,
    width: 107.311,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9902_29174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_9902_29174",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9902_29174",
    x1: 35.8505,
    y1: 20.5082,
    x2: 35.8505,
    y2: 75.4085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743BBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9902_29174",
    x1: 76.877,
    y1: 23.3881,
    x2: 29.8985,
    y2: 69.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersons);
export default __webpack_public_path__ + "static/media/persons.f93a553d4b21835e78c881d87a068945.svg";
export { ForwardRef as ReactComponent };